import { Component } from "react";
import { initialUiLang, makeT } from "@/lib/i18n";

// Around the whole app (App.js): one message the screen can't draw — a
// reply in a shape this build didn't expect, a panel's slip — used to blank
// the page until a reload, with nothing said (audit client-11). Now it says
// so, in the interface language (the one saved last: luna_lang), with a
// button that reloads. onReload: for tests; the page's own reload otherwise.
export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // (the browser console only — nothing about it reaches the screen)
    console.error("App failed to render:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    const t = makeT(initialUiLang());
    const reload = this.props.onReload || (() => window.location.reload());
    return (
      <div className="h-app flex items-center justify-center bg-[#05040c] px-4 text-white" role="alert"
        data-testid="app-error-boundary">
        <div className="w-full max-w-sm rounded-3xl border border-purple-400/20 bg-[#0c0818] p-6 text-center">
          <p className="text-base font-semibold">{t("Bir şeyler ters gitti — sayfayı yenile", "Something went wrong — reload the page")}</p>
          <p className="mt-2 text-sm text-white/60">
            {t("Sohbetlerin ve dosyaların yerinde; yenileyince kaldığın yerden devam edersin.",
              "Your chats and files are safe; reloading picks up where you left off.")}
          </p>
          <button type="button" onClick={reload} data-testid="app-error-reload-button"
            className="mt-5 w-full rounded-full bg-gradient-to-r from-indigo-500 to-fuchsia-500 py-2.5 text-sm font-semibold text-white transition hover:brightness-110">
            {t("Sayfayı yenile", "Reload")}
          </button>
        </div>
      </div>
    );
  }
}
